import React, { useState, useEffect } from 'react';
import Header from '../Header/Header.jsx';
import Footer from '../Footer/Footer.jsx';
import styles from './IllustrationArt.module.css';
import Image1 from '../../images/kadhakali.svg'
import Image2 from '../../images/train.svg'
import Image3 from '../../images/buddha.svg'
import Image4 from '../../images/Monalisa.svg'
import Image5 from '../../images/illustration-lady.png'
import Image6 from '../../images/3D-penguin.svg'
import Image7 from '../../images/lady.svg'
import Image8 from '../../images/3d-rabbit.svg'
import AdobeLogo from '../../images/illustrator.png'
import Pen from '../../images/pen-tool.png'

const IllustrationGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [hoveredId, setHoveredId] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mode, setMode] = useState('graphic');

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const illustrations = [
    {
      id: 1,
      url: Image1,
      description: 'Kathakali, originating from Kerala in the 17th century, showcases elaborate costumes and makeup, depicts Hindu epics through dance and gestures, accompanied by music, requiring extensive training.',
      icon1: Pen,
      colors: ['#eb1b48', '#91b13d', '#edc232', '#ef8721', '#623335', '#e4e7f4', '#8fa6d5'],
      icon2: AdobeLogo
    },
    {
      id: 2,
      url: Image2,
      description: 'Simple scenery which is created in Illustrator',
      icon1: Pen,
      colors: ['#739aa9', '#21512c', '#f7faf8', '#923e21', '#5b1a17', '#221b13', '#f4f5f6'],
      icon2: AdobeLogo
    },
    {
      id: 3,
      url: Image3,
      description: 'Siddhartha Gautama,founded Buddhism in 5th-4th century BCE India. He taught the Four Noble Truths, emphasizing life’s suffering and the path to enlightenment through the Noble Eightfold Path and achieving Nirvana.',
      icon1: Pen,
      colors: ['#582834', '#f4f3f4', '#d99e5a', '#dd6c3d', '#d14a2d', '#231e20'],
      icon2: AdobeLogo
    },
    {
      id: 4,
      url: Image4,
      description: 'The Mona Lisa ,painted by Leonardo da Vinci, features the enigmatic Lisa Gherardini. Renowned for its sfumato technique, it’s among the world’s most famous artworks.',
      icon1: Pen,
      colors: ['#101117', '#8fa8ce', '#6b553c', '#edb579C', '#fed4a4', '#3a211b'],
      icon2: AdobeLogo
    },
    {
      id: 5,
      url: Image5,
      description: 'The Lady with the bird, is a modern art illustration, which highlights Freedom is a state of mind. Go where you breath free.',
      icon1: Pen,
      colors: ['#e8adc4', '#835995', '#d26092', '#e91f24', '#d3b62a', '#2e2a51'],
      icon2: AdobeLogo
    },
    {
      id: 6,
      url: Image6,
      description: 'Simple animal 3D avatar created using Illustrator',
      icon1: Pen,
      colors: ['#2c3e50', '#3498db', '#ecf0f1', '#f39c12', '#e74c3c', '#9b59b6'],
      icon2: AdobeLogo
    },
    {
      id: 7,
      url: Image7,
      description: 'Bharatanatyam ,rooted in Natya Shastra, combines precise footwork, expressive gestures, and emotive facial cues with traditional attire, accompanied by classical Indian music, emphasizing rhythm, melody, and storytelling.',
      icon1: Pen,
      colors: ['#8e44ad', '#e67e22', '#f1c40f', '#e74c3c', '#2ecc71', '#3498db'],
      icon2: AdobeLogo
    },
    {
      id: 8,
      url: Image8,
      description: 'Simple animal 3D avatar created using Illustrator',
      icon1: Pen,
      colors: ['#34495e', '#e67e22', '#f39c12', '#27ae60', '#8e44ad', '#ecf0f1'],
      icon2: AdobeLogo
    }
  ];

  return (
    <>
      <Header mode={mode} setMode={setMode} menuOpen={menuOpen} setMenuOpen={setMenuOpen} scrolled={scrolled} />
      
      <div className={styles.container}>
        {/* Animated Background */}
        <div className={styles.animatedBackground}>
          <div className={styles.particlesWrapper}>
            {[...Array(30)].map((_, i) => (
              <div key={i} className={styles.particle} />
            ))}
          </div>
          <div className={`${styles.gradientOrb} ${styles.orb1}`} />
          <div className={`${styles.gradientOrb} ${styles.orb2}`} />
          <div className={`${styles.gradientOrb} ${styles.orb3}`} />
          <div className={`${styles.gradientOrb} ${styles.orb4}`} />
          
          <div className={styles.floatingIcons}>
            <div className={styles.floatingIcon} style={{ top: '15%', left: '10%' }}>🎨</div>
            <div className={styles.floatingIcon} style={{ top: '70%', right: '15%' }}>✨</div>
            <div className={styles.floatingIcon} style={{ bottom: '20%', left: '20%' }}>🖌️</div>
            <div className={styles.floatingIcon} style={{ top: '40%', right: '25%' }}>⭐</div>
          </div>
        </div>

        <div className={styles.contentWrapper}>
          {/* Header */}
          <div className={styles.headerSection}>
            <h1 className={styles.galleryTitle}>
              <span className={styles.titleWord}>Illustration</span>
              <span className={styles.titleWord}>Art</span>
              <span className={styles.titleWord}>Gallery</span>
            </h1>
            <div className={styles.titleDecoration} />
          </div>

          {/* Description */}
          <div className={styles.descriptionSection}>
            <div className={styles.descriptionCard}>
              <div className={styles.quoteIcon}>"</div>
              <p className={styles.descriptionText}>
                Each illustration is a journey into imagination, blending colors, emotions, and stories into visual masterpieces. From abstract concepts to detailed narratives, these artworks capture the essence of creative expression.
              </p>
            </div>
          </div>

          {/* Gallery Grid */}
          <div className={styles.galleryGrid}>
            {illustrations.map((item, index) => (
              <div
                key={item.id}
                className={styles.galleryItem}
                style={{ animationDelay: `${index * 0.15}s` }}
                onMouseEnter={() => setHoveredId(item.id)}
                onMouseLeave={() => setHoveredId(null)}
              >
                <div
                  className={styles.imageWrapper}
                  style={{
                    transform: hoveredId === item.id ? 'translateY(-15px) scale(1.02)' : 'translateY(0) scale(1)',
                    boxShadow: hoveredId === item.id
                      ? '0 25px 60px rgba(255, 107, 157, 0.4), 0 10px 25px rgba(0, 0, 0, 0.5)'
                      : '0 10px 30px rgba(0, 0, 0, 0.3)'
                  }}
                  onClick={() => setSelectedImage(item)}
                >
                  <img src={item.url} alt={item.title} className={styles.image} />
                  
                  <div className={styles.glowEffect} style={{ opacity: hoveredId === item.id ? 1 : 0 }} />
                </div>

                <div className={styles.infoSection}>
                  <p className={styles.itemDescription}>{item.description}</p>
                  
                  <div className={styles.metaSection}>
                    <div className={styles.iconDisplay}><img src={item.icon1} alt="pen tool" /></div>

                    <div className={styles.colorPalette}>
                      {item.colors.map((color, idx) => (
                        <div
                          key={idx}
                          className={styles.colorSwatch}
                          style={{ backgroundColor: color, animationDelay: `${idx * 0.1}s` }}
                          title={color}
                        />
                      ))}
                    </div>

                    <div className={styles.iconDisplay}><img src={item.icon2} alt="icon2" /></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Modal */}
        {selectedImage && (
          <div className={styles.modalOverlay} onClick={() => setSelectedImage(null)}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
              <button className={styles.closeBtn} onClick={() => setSelectedImage(null)}>
                <span className={styles.closeLine1}></span>
                <span className={styles.closeLine2}></span>
              </button>
              <div className={styles.modalImageWrapper}>
                <img src={selectedImage.url} alt={selectedImage.title} className={styles.modalImage} />
                <div className={styles.modalGlow} />
              </div>
            </div>
          </div>
        )}
      </div>

      <div className={styles.footerOverride}>
        <Footer />
      </div>
    </>
  );
};

export default IllustrationGallery;